<template>
  <v-container fluid>
    <PageHeader title="Profiles" icon="mdi-account-group">
      <template #actions>
        <v-btn color="primary" @click="addNew"><v-icon start>mdi-plus</v-icon> New Profile</v-btn>
      </template>
    </PageHeader>
    <v-card>
      <div class="ml-4 mb-4">
        <v-text-field
          v-model="searchQuery"
          prepend-icon="mdi-magnify"
          :label="searchLabel"
          single-line
          hide-details
          variant="underlined"
          class="mr-4"
        ></v-text-field>
      </div>
      <v-data-table
        :items-per-page="-1"
        :must-sort="true"
        :no-data-text="''"
        :headers="headers"
        :items="orgunits"
        :loading="loading"
        :search="searchQuery"
        v-model:sort-by="sortBy"
        @click:row="(event, { item }) => selectOrgUnit(item)"
      >
        <template v-slot:item.icon="{}">
          <v-icon>mdi-account-group</v-icon>
        </template>
        <template v-slot:item.name="{ item }">
          <div v-html="highlight(item.name, searchQuery)"></div>
        </template>
        <template v-slot:item.code="{ item }">
          <div v-html="highlight(item.code, searchQuery)"></div>
        </template>
        <template v-slot:item.addressLineOne="{ item }">
          <div v-html="highlight(item.addressLineOne, searchQuery)"></div>
        </template>
        <template v-slot:item.addressLineTwo="{ item }">
          <div v-html="highlight(item.addressLineTwo, searchQuery)"></div>
        </template>
        <template v-slot:item.city="{ item }">
          <div v-html="highlight(item.city, searchQuery)"></div>
        </template>
        <template v-slot:item.zipCode="{ item }">
          <div v-html="highlight(item.zipCode, searchQuery)"></div>
        </template>
        <template v-slot:item.phone="{ item }">
          <div v-html="highlight(item.phone, searchQuery)"></div>
        </template>

        <template v-slot:bottom></template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import orgUnitService from "@/services/admin/orgUnitService";
import Auth0Mixin from "../Auth0Mixin";
import filterService from "@/services/filterService.js";
import searchUtilsService from "@/services/searchUtilsService.js";
import localStorageService from "@/services/localStorageService.js";
import terminologyService from "@/services/terminologyService.js";
import terminology from "@/constants/terminology";

import PageHeader from "@/components/PageHeader.vue";

export default {
  name: "OrgUnits",
  mixins: [Auth0Mixin],
  components: { PageHeader },
  data() {
    let state = localStorageService.get("orgUnitList");

    return {
      headers: [
        { title: "", key: "icon", width: 40, sortable: false },
        { title: "Name", key: "name" },
        { title: "Code", key: "code" },
        { title: "Address line 1", key: "addressLineOne" },
        { title: "Address line 2", key: "addressLineTwo" },
        { title: "City", key: "city" },
        { title: "Zip Code", key: "zipCode" },
        { title: "Phone number", key: "phone" },
        {
          title: "Is Active",
          key: "isActive",
        },
      ],
      sortBy: [{ key: "name", order: "asc" }],
      orgunits: [],
      searchQuery: state ? state.query : "",
      loading: true,
      highlight: filterService.highlight,
    };
  },

  watch: {
    searchQuery: function() {
      localStorageService.save("orgUnitList", { query: this.searchQuery });
    },
  },

  computed: {
    searchLabel: function() {
      return searchUtilsService.getLabel(terminologyService.lookup(terminology.ORG_UNIT), this.orgunits);
    },
  },

  methods: {
    async init() {
      const result = await orgUnitService.getList(false);
      this.orgunits = result.items;
      this.loading = false;
    },

    async addNew() {
      this.$router.push(`/admin/orgunit/create`);
    },

    selectOrgUnit(orgunit) {
      this.$router.push(`/admin/orgunit/${orgunit.id}`);
    },
  },
};
</script>
